import { render, staticRenderFns } from "./palletDetail.vue?vue&type=template&id=9c6712ca&scoped=true"
import script from "./palletDetail.vue?vue&type=script&lang=js"
export * from "./palletDetail.vue?vue&type=script&lang=js"
import style0 from "./palletDetail.vue?vue&type=style&index=0&id=9c6712ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6712ca",
  null
  
)

export default component.exports